// Centralized environment parsing with minimal validation
// Note: Vite injects import.meta.env at build time

type Env = {
  apiBaseUrl: string
  apiPrefix: string
  apiVersion: string
  supportEmail: string
  privacyUrl: string
  termsUrl: string
  encryptionKey: string
  sentryDsn: string
  sentryEnvironment: string
  enableSentry: boolean
  enableSentryReplays: boolean
}

function trimSlashes(input: string) {
  return input.replace(/\/+$/g, '').replace(/^\/+/, '')
}

function ensureLeadingSlash(input: string) {
  return input.startsWith('/') ? input : `/${input}`
}

const rawEnv = (import.meta as any).env ?? {}

export const env: Env = {
  apiBaseUrl: rawEnv.VITE_API_BASE_URL || '',
  apiPrefix: rawEnv.VITE_API_API_PREFIX || 'api',
  apiVersion: rawEnv.VITE_API_VERSION || 'v1',
  supportEmail: rawEnv.VITE_APP_SUPPORT_EMAIL || '',
  privacyUrl: rawEnv.VITE_APP_PRIVACY_URL || '',
  termsUrl: rawEnv.VITE_APP_TERMS_URL || '',
  encryptionKey: rawEnv.VITE_STORAGE_ENCRYPTION_KEY || '',
  sentryDsn: rawEnv.VITE_SENTRY_DSN || '',
  sentryEnvironment: rawEnv.VITE_SENTRY_ENVIRONMENT || '',
  enableSentry: rawEnv.VITE_ENABLE_SENTRY === 'true',
  enableSentryReplays: rawEnv.VITE_ENABLE_SENTRY_REPLAYS === 'true',
}

export const normalizedEnv = {
  apiBaseUrl: trimSlashes(env.apiBaseUrl),
  apiPrefix: trimSlashes(env.apiPrefix),
  apiVersion: trimSlashes(env.apiVersion),
  supportEmail: env.supportEmail.trim(),
  privacyUrl: env.privacyUrl.trim(),
  termsUrl: env.termsUrl.trim(),
  encryptionKey: env.encryptionKey.trim(),
  sentryDsn: env.sentryDsn.trim(),
  sentryEnvironment: env.sentryEnvironment.trim(),
  enableSentry: env.enableSentry,
  enableSentryReplays: env.enableSentryReplays,
}

export const runtime = {
  isDev: rawEnv.DEV === true,
  isProd: rawEnv.PROD === true,
  mode: rawEnv.MODE as string | undefined,
}

export const pathUtils = { ensureLeadingSlash, trimSlashes }
